import React, { useState } from "react";
import {
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@material-ui/core";
import { Inbox as InboxIcon } from "@material-ui/icons";
import classnames from "classnames";
import { useRecoilState } from "recoil";
import { memberTableState, projectTableState, noticeTableState } from "../../../../recoil/tableSetting";
import { useHistory } from "react-router-dom";

// styles
import useStyles from "./styles";

// components
import Dot from "../Dot";

export default function SidebarLink({
                                      link,
                                      icon,
                                      label,
                                      children,
                                      location,
                                      isSidebarOpened,
                                      nested,
                                      type,
                                    }) {
  var classes = useStyles();
  const history = useHistory(); // useHistory 사용

  // local
  var [isOpen, setIsOpen] = useState(false);
  var isLinkActive = link && location.pathname === link;

  const [, setMemberTable] = useRecoilState(memberTableState);
  const [, setProjectTable] = useRecoilState(projectTableState);
  const [, setNoticeTable] = useRecoilState(noticeTableState);

  // 클릭 시 동작 처리
  const handleLinkClick = (e, link) => {
    switch (link) {
      case "/app/researchAll/member":
        setMemberTable("total");
        break;
      case "/app/researchAll/project":
        setProjectTable("total");
        break;
      case "/app/researchAll/memberCenter":
        setNoticeTable("notice");
        break;
      default:
        break;
    }

    history.push(link); // 페이지 이동
  };


  if (type === "title")
    return (
      <Typography
        className={classnames(classes.linkText, classes.sectionTitle, {
          [classes.linkTextHidden]: !isSidebarOpened,
        })}
      >
        {label}
      </Typography>
    );

  if (type === "divider") return <Divider className={classes.divider} />;
  if (link && link.includes("http")) {
    return (
      <ListItem
        button
        className={classes.link}
        classes={{
          root: classnames(classes.linkRoot, {
            [classes.linkActive]: isLinkActive && !nested,
            [classes.linkNested]: nested,
          }),
        }}
        disableRipple
      >
        <a className={classes.externalLink} href={link}>
          <ListItemIcon
            className={classnames(classes.linkIcon, {
              [classes.linkIconActive]: isLinkActive,
            })}
          >
            {nested ? <Dot color={isLinkActive && "primary"} /> : icon}
          </ListItemIcon>
          <ListItemText
            classes={{
              primary: classnames(classes.linkText, {
                [classes.linkTextActive]: isLinkActive,
                [classes.linkTextHidden]: !isSidebarOpened,
              }),
            }}
            primary={label}
          />
        </a>
      </ListItem>
    );
  }

  if (!children)
    return (
      <ListItem
        button
        onClick={(e) => handleLinkClick(e, link)} // onClick을 사용하여 함수 호출
        className={classes.link}
        classes={{
          root: classnames(classes.linkRoot, {
            [classes.linkActive]: isLinkActive && !nested,
            [classes.linkNested]: nested,
          }),
        }}
        disableRipple
      >
        <ListItemIcon
          className={classnames(classes.linkIcon, {
            [classes.linkIconActive]: isLinkActive,
          })}
        >
          {nested ? <Dot color={isLinkActive && "primary"} /> : icon}
        </ListItemIcon>
        <ListItemText
          classes={{
            primary: classnames(classes.linkText, {
              [classes.linkTextActive]: isLinkActive,
              [classes.linkTextHidden]: !isSidebarOpened,
            }),
          }}
          primary={label}
        />
      </ListItem>
    );

  return (
    <>
      <ListItem
        button
        onClick={toggleCollapse} // onClick 시 collapse 처리
        className={classes.link}
        disableRipple
      >
        <ListItemIcon
          className={classnames(classes.linkIcon, {
            [classes.linkIconActive]: isLinkActive,
          })}
        >
          {icon ? icon : <InboxIcon />}
        </ListItemIcon>
        <ListItemText
          classes={{
            primary: classnames(classes.linkText, {
              [classes.linkTextActive]: isLinkActive,
              [classes.linkTextHidden]: !isSidebarOpened,
            }),
          }}
          primary={label}
        />
      </ListItem>
      {children && (
        <Collapse
          in={isOpen && isSidebarOpened}
          timeout="auto"
          unmountOnExit
          className={classes.nestedList}
        >
          <List component="div" disablePadding>
            {children.map((childrenLink) => (
              <SidebarLink
                key={childrenLink && childrenLink.link}
                location={location}
                isSidebarOpened={isSidebarOpened}
                classes={classes}
                nested
                {...childrenLink}
              />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );

  // ###########################################################

  function toggleCollapse(e) {
    if (isSidebarOpened) {
      e.preventDefault();
      setIsOpen(!isOpen);
    }
  }
}
